import { PanelType } from '../../../../../../panels/types';
import { PluginPanelData } from '../../../panel/BasePluginPanel';

export const dataManagementPanelType: PanelType<PluginPanelData> = {
  name: 'DATA_MANAGEMENT_PANEL',
  location: 'left',
};
